﻿export interface INewFileUpload {
    date: string;
    documentsVersionId: number;
    file: File;
}
